import React, { useState, useRef, useEffect } from 'react'
import { FaCircleCheck } from 'react-icons/fa6'
import { MdInfo } from 'react-icons/md'

export const SubscriptionFeature = ({
  color,
  text,
  additionalInfo,
}: {
  color?: string
  text: string
  additionalInfo?: string
}) => {
  const [infoOpen, setInfoOpen] = useState<boolean>(false)
  const modalRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setInfoOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const toggleInfo = () => setInfoOpen(!infoOpen)

  return (
    <div
      className={`${color} flex flex-col md:flex-row gap-2 justify-between items-center p-4 rounded-md`}
    >
      <div className='flex text-center md:text-start items-start md:items-center'>
        <p className='text-xs md:text-sm font-normal md:font-medium pr-[10px]'>
          {text}
        </p>

        {additionalInfo && (
          <button onClick={toggleInfo}>
            <MdInfo color='#8DD8EB' />

            {infoOpen && (
              <div
                ref={modalRef}
                className='absolute text-xs max-w-[240px] bg-[#37A2BA] rounded-lg text-white p-[14px]'
              >
                {additionalInfo}
              </div>
            )}
          </button>
        )}
      </div>

      <div>
        <FaCircleCheck color='#58C1B3' />
      </div>
    </div>
  )
}
